import {
    UPDATE_CALCULATOR_STATE
} from './types';

export const updateCalculatorState = (calcState) => dispatch => {
    dispatch({
        type: UPDATE_CALCULATOR_STATE,
        payload: calcState
    })
}